import { useState, type FC } from 'react';
import { Button, Space } from '@g2u/ui-kit';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { PutTicketParams } from 'queries';
import { type WithOptionalDataTest } from 'types';
import { useHardwareReturn } from '../hooks/useHardwareReturn';

type Props = {
  ticketId: number;
  technicianId: number;
  date: string;
  onUpdate: (payload: PutTicketParams) => void;
} & WithOptionalDataTest;

export const TicketHardwareReturn: FC<Props> = (props) => {
  const { date, onUpdate, ticketId, technicianId } = props;
  const isReturnDateValid = date !== '0000-00-00 00:00:00' && dayjs(date).isValid();

  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const [pickerValue, setPickerValue] = useState((isReturnDateValid ? dayjs(date) : dayjs()).startOf('month'));
  const { disabledDate, disabledTime } = useHardwareReturn(technicianId, pickerValue);

  const handleSetDate = (date: dayjs.Dayjs | null) => {
    if (!date) return;
    onUpdate({
      ticketId,
      etaDate: date.format('YYYY-MM-DD HH:mm:ss'),
      successMessage: 'Hardware return date saved',
    });
  };

  const handleRemoveDate = () => {
    onUpdate({ ticketId, hasRemoveEta: true, successMessage: 'Hardware Return Date has been removed' });
  };

  return (
    <Space.$ style={{ marginBottom: 16 }} justify={Space.Justify.SpaceBetween}>
      Hardware Return Time:{'  '}
      <Space.$ justify={Space.Justify.End}>
        <DatePicker
          name="hwReturnDate"
          value={isReturnDateValid ? dayjs(date) : undefined}
          showTime={{ minuteStep: 30 }}
          open={isPickerOpen}
          onOpenChange={setIsPickerOpen}
          pickerValue={pickerValue}
          onPanelChange={(next) => {
            if (!next) return;
            setPickerValue(next.startOf('month'));
          }}
          allowClear={false}
          format="YYYY-MM-DD HH:mm"
          onChange={handleSetDate}
          disabledDate={disabledDate}
          disabledTime={disabledTime}
        />
        {isReturnDateValid && (
          <Button.$ danger dataTestId="remove-date" onClick={handleRemoveDate}>
            Delete
          </Button.$>
        )}
      </Space.$>
    </Space.$>
  );
};
